export default "__VITE_PUBLIC_ASSET__e720c6f7__"